import { IAccount, IBalanceSwitchAccount } from '@modeso/types__aumico-lib-annualreport-be';
import { ITemplateEntityDTO } from '@modeso/types__aumico-lib-templates-be';
import { AccountMappingTemplateStatus } from '../enums/account-mapping-template-status.enum';

export interface IAccountMappingDataNew {
    template: ITemplateEntityDTO;
    status: AccountMappingTemplateStatus.NEW;
    accounts: IAccount[];
    balanceSwitchAccounts?: IBalanceSwitchAccount[];
}
